import { STORAGE_KEYS } from '@/lib/api/storageKeys'

/**
 * "마지막으로 본 구장" **로컬 기억 장치**.
 *
 * 🚨 갭 G1 은 닫혔다 — 관리 구장 **목록의 정본은 서버**(`GET /venue/v1/manager/venues`, #584 §1)이며
 * `hooks/useManagedVenues.ts` 가 소유한다. 이 어댑터에는 목록 기능이 없다(설계 D8에서 `list()` 제거).
 * 여기 남은 것은 *"새로고침·재로그인 후 어느 구장으로 돌아갈까"* 라는 **편의값 하나**뿐이다.
 *
 * ⚠️ 이 값은 **권한 경계가 아니다.** 소유권은 서버가 행 단위로 검증한다(403). 저장된 구장을
 * 더 이상 관리하지 않게 되면 `VenueLayout` 이 안내와 함께 이 값을 잊는다.
 */
export interface ManagedVenueMemory {
  /** 진입 시 사용할 기본 구장. 없으면 null → 구장 선택 화면으로 보낸다. */
  resolveInitial(): string | null
  remember(venueId: string): void
  forget(): void
}

/** 양의 정수 형태의 문자열만 구장 id 로 인정한다. `"1abc"`·`"-3"`·`"0"` 은 거부. */
export function parseVenueId(raw: string | null | undefined): string | null {
  if (raw === null || raw === undefined) return null
  const trimmed = String(raw).trim()
  return /^[1-9]\d*$/.test(trimmed) ? trimmed : null
}

export const localManagedVenueSource: ManagedVenueMemory = {
  /**
   * 마지막 선택(localStorage)만 본다.
   * 🚨 `VITE_DEFAULT_VENUE_ID` 폴백은 **제거했다**(설계 D8) — 서버가 목록을 주는 지금,
   * 빌드 상수로 구장 번호를 기본값으로 밀어 넣을 이유가 없다.
   */
  resolveInitial() {
    return parseVenueId(localStorage.getItem(STORAGE_KEYS.lastVenueId))
  },

  remember(venueId: string) {
    localStorage.setItem(STORAGE_KEYS.lastVenueId, String(venueId))
  },

  forget() {
    localStorage.removeItem(STORAGE_KEYS.lastVenueId)
  },
}
